import { Injectable } from '@angular/core';
import { Website } from '../../../websites/models/website';
import { LocalStorageService } from 'angular-2-local-storage';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class WebsiteTogglerService {
  private storageKey = 'currentWebsite';
  public _load: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  get isLoaded$$() {
    return this._load.asObservable();
  }
  set website(website: Website) {
    this.localStorageService.set(this.storageKey, website);
  }

  get website(): Website {
    return this.localStorageService.get<Website>(this.storageKey);
  }

  constructor(
    private localStorageService: LocalStorageService
  ) { }

  removeWebsite() {
    this.localStorageService.remove(this.storageKey);
  }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/components/websites-toggler/services/website-toggler.service.ts